import { Select } from 'components/partials/select/select';

export interface AwardLogicOption {
  value: string;
  label: string;
}

export interface AwardLogicCellProps {
  value: string | null | undefined;
  options: AwardLogicOption[];
  onChange: (value: string) => void;
  'data-testid'?: string;
}

const selectControlStyles = {
  minHeight: '32px',
  height: '32px',
  padding: '0',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
};

const getSelectAlignmentStyles = (): Record<string, unknown> => ({
  valueContainer: (base: Record<string, unknown>) => ({
    ...base,
    height: '30px',
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
  }),
  singleValue: (base: Record<string, unknown>) => ({
    ...base,
    margin: 0,
    lineHeight: '20px',
  }),
  placeholder: (base: Record<string, unknown>) => ({
    ...base,
    margin: 0,
    lineHeight: '20px',
  }),
  input: (base: Record<string, unknown>) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base: Record<string, unknown>) => ({
    ...base,
    height: '30px',
    alignItems: 'center',
  }),
  dropdownIndicator: (base: Record<string, unknown>) => ({
    ...base,
    padding: '0 8px 0 4px',
  }),
  menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 9999 }),
});

const AwardLogicCell = ({
  value,
  options,
  onChange,
  'data-testid': dataTestId = 'award-logic-cell',
}: AwardLogicCellProps) => {
  const selected = options.find((option) => option.value === value) ?? null;

  return (
    <Select
      options={options}
      value={selected ?? undefined}
      onChange={(option) => {
        if (option && !Array.isArray(option)) {
          onChange(String(option.value));
        }
      }}
      isSearchable={false}
      placeholder="Select..."
      aria-label="Awarding logic"
      extraBasicStyles={selectControlStyles}
      extraStyles={getSelectAlignmentStyles}
      menuPortalTarget={document.body}
      data-testid={dataTestId}
    />
  );
};

export default AwardLogicCell;
